.UnitSprite {
  width: 4em;
  height: 3em;
  left: -1.45em;
  right: -1.5em;
  bottom: -0.5em;
  margin: auto;
  position: absolute;
  background-size: 4em auto;
  background-repeat: no-repeat;
  background-position: center bottom;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  opacity: 1;
  transition-property: filter;
  transition-duration: 0.6s;
  filter: grayscale(0%) brightness(100%) saturate(100%);
}
.UnitSprite[pixelated] {
  image-rendering: pixelated;
}
.UnitSprite[spriteSize="1x1"],
.UnitSprite[spriteSize=contained] {
  background-size: contain;
  width: 1em;
  height: 1em;
  left: 0em;
  right: 0em;
  bottom: 0em;
}
.UnitSprite[spriteSize="4x3"] {
  background-size: contain;
  width: 1.5996em;
  height: 1.2em;
  left: -1em;
  right: -1em;
  bottom: 0em;
}
.UnitSprite[spriteSize="3x3"] {
  background-size: contain;
  width: 3em;
  height: 3em;
  left: -1em;
  top: -1em;
  margin: 0;
}
.UnitSprite[spriteSize=buffered] {
  background-size: contain;
  width: 1.5em;
  height: 1.5em;
  left: -0.5em;
  right: -0.5em;
  bottom: -0.25em;
}
.UnitSprite .Face,
.UnitSprite .Body,
.UnitSprite .Weapon,
.UnitSprite .Decal,
.UnitSprite .Sprite,
.UnitSprite .SpritePart {
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: bottom;
  mask-size: 100% auto;
  mask-repeat: no-repeat;
  mask-position: bottom;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  transform: scale(1);
  transition-property: transform;
  transition-duration: 1s;
  transform-origin: center bottom;
}
.UnitSprite .Face[isHidden],
.UnitSprite .Body[isHidden],
.UnitSprite .Weapon[isHidden],
.UnitSprite .Decal[isHidden],
.UnitSprite .Sprite[isHidden],
.UnitSprite .SpritePart[isHidden] {
  display: none;
}
.UnitSprite .Face[isBig],
.UnitSprite .Body[isBig],
.UnitSprite .Weapon[isBig],
.UnitSprite .Decal[isBig],
.UnitSprite .Sprite[isBig],
.UnitSprite .SpritePart[isBig] {
  transform: scale(1.2);
  transition-duration: 0.25s;
}
.UnitSprite[animationKey=breathing] .Face[type=body],
.UnitSprite[animationKey=breathing] .Body[type=body],
.UnitSprite[animationKey=breathing] .Weapon[type=body],
.UnitSprite[animationKey=breathing] .Decal[type=body],
.UnitSprite[animationKey=breathing] .Sprite[type=body],
.UnitSprite[animationKey=breathing] .SpritePart[type=body] {
  animation-name: bodyshake;
}
.UnitSprite[animationKey=breathing] .Face[type=head],
.UnitSprite[animationKey=breathing] .Body[type=head],
.UnitSprite[animationKey=breathing] .Weapon[type=head],
.UnitSprite[animationKey=breathing] .Decal[type=head],
.UnitSprite[animationKey=breathing] .Sprite[type=head],
.UnitSprite[animationKey=breathing] .SpritePart[type=head] {
  animation-name: headshake;
}
.UnitSprite[animationKey=bob] .Face[type=body],
.UnitSprite[animationKey=bob] .Body[type=body],
.UnitSprite[animationKey=bob] .Weapon[type=body],
.UnitSprite[animationKey=bob] .Decal[type=body],
.UnitSprite[animationKey=bob] .Sprite[type=body],
.UnitSprite[animationKey=bob] .SpritePart[type=body] {
  animation-name: bob;
}
.UnitSprite[animationKey=rockout] {
  animation-duration: 845.070423ms;
  animation-direction: alternate;
  animation-name: rockout;
  transform-origin: center bottom;
}
.UnitSprite[animationKey=rockout][affiliation="ally"] {
  animation-name: unrockout;
}
.UnitSprite[animationKey=squigglevision] {
  animation-name: squigglevision;
  animation-duration: 0.5s;
}
.UnitSprite[recolor=whitedout] {
  filter: grayscale(100%) brightness(100%) saturate(0%);
}
.UnitSprite[recolor=grayscaled] {
  filter: grayscale(50%) brightness(100%) saturate(0%);
}
.UnitSprite[recolor=blackedout] {
  filter: grayscale(0%) brightness(0%);
}
.UnitSprite[isInvisible] {
  opacity: 0;
}
.UnitSprite[isFlipped] {
  transform: scaleX(-1);
}
.LegacySpot {
  width: 0.8em;
  height: 0.8em;
  margin: auto;
  left: 0em;
  right: 0em;
  bottom: 0em;
  top: 0em;
  position: absolute;
  border-radius: 50%;
  background-color: #555;
  opacity: 0.5;
}
[pixelated] .UnitSprite {
  image-rendering: pixelated;
}
[pixelated] .WorldImage {
  image-rendering: pixelated;
}
[gamekey=hero] .CreditsScreen .Title img {
  image-rendering: pixelated;
}
[gamekey=hero] .CreditsScreen .Contributor .Name {
  text-shadow: 0.1em 0.1em 0.1em #000;
}
[gamekey=hero] .CreditsScreen .Contributor .Sprite {
  image-rendering: pixelated;
  background-size: contain !important;
}
@keyframes bob {
  0% {
    transform: translateY(0em);
  }
  50% {
    transform: translateY(-0.1em);
  }
  100% {
    transform: translateY(0em);
  }
}
@keyframes headshake {
  0% {
    transform: translateY(0em);
  }
  15% {
    transform: translateY(0em);
  }
  50% {
    transform: translateY(-0.025em);
  }
  60% {
    transform: translateY(-0.025em);
  }
  95% {
    transform: translateY(0em);
  }
  100% {
    transform: translateY(0em);
  }
}
@keyframes bodyshake {
  0% {
    transform: translateY(0em);
  }
  10% {
    transform: translateY(0em);
  }
  45% {
    transform: translateY(-0.025em);
  }
  55% {
    transform: translateY(-0.025em);
  }
  90% {
    transform: translateY(0em);
  }
  100% {
    transform: translateY(0em);
  }
}
@keyframes unrockout {
  0% {
    transform: rotate(-4deg);
  }
  100% {
    transform: rotate(4deg);
  }
}
@keyframes rockout {
  0% {
    transform: rotate(4deg);
  }
  100% {
    transform: rotate(-4deg);
  }
}
